// ====== ./app/app.routes.ts ======

// Imports
// Deprecated import
// import { provideRouter, RouterConfig } from '@angular/router';
import { ModuleWithProviders }  from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PriceComponent } from './price/price.component';
import { HomeComponent } from './home/home.component';
import { PlaceHolderComponent } from './place-holder/place-holder.component';
import { PaymentComponent } from './payment/payment.component';
import { AboutComponent } from './about/about.component';
import {ContactComponent } from './contact/contact.component';
import { NotFoundComponent}  from './not-found/not-found.component';
import { VerificationComponent } from './verification/verification.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { EditProfileComponent } from './edit-profile/edit-profile.component';
import { ViewProfileComponent } from './view-profile/view-profile.component';
import { MyPaymentComponent } from './my-payment/my-payment.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { MyOrderComponent } from './my-order/my-order.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { DriverResetPasswordComponent } from './driver-reset-password/driver-reset-password.component';
import { SignupComponent } from './signup/signup.component';
import { UpdateCardComponent } from './update-card/update-card.component';




import { AuthGuard } from './auth/auth.guard';
// Route Configuration
export const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'reset-password/:token', component: ResetPasswordComponent },
  { path: 'reset-password/driver/:token', component: DriverResetPasswordComponent },
  { path: 'pricing', component: PriceComponent },
  { path: 'user/:token/:type', component: VerificationComponent },
  { path: 'place-order', component: PlaceHolderComponent , canActivate: [ AuthGuard ]},
  { path: 'payment', component: PaymentComponent },
  { path: 'aboutus', component: AboutComponent },
  { path: 'terms', component: AboutComponent },
  { path: 'contact', component: ContactComponent },
  { path: 'signup', component: SignupComponent },
  { path: 'update-card', component: UpdateCardComponent},

  { path: 'change-password', component: ChangePasswordComponent , canActivate: [ AuthGuard ]},
  { path: 'edit-profile', component: EditProfileComponent , canActivate: [ AuthGuard ]},
  { path: 'view-profile', component: ViewProfileComponent , canActivate: [ AuthGuard ]},
  { path: 'my-payment', component: MyPaymentComponent },
  { path: 'forgot-password', component: ForgotPasswordComponent },
  { path: 'my-order', component: MyOrderComponent , canActivate: [ AuthGuard ]},
  
  
  

  
  {path: '**',  component: NotFoundComponent},
  
];

// Deprecated provide
// export const APP_ROUTER_PROVIDERS = [
//   provideRouter(routes)
// ];

export const routing: ModuleWithProviders = RouterModule.forRoot(routes);



// WEBPACK FOOTER //
// D:/xampp/htdocs/laundry-pickup/laundry-pickup-website/src/app/app.routes.ts